namespace Ir.Components.Filters.DateRangeFilter {
    interface IDateRangeFilterViewModel {
        filter: Filter;
        dateRanges: Array<DateRange>;
        dateFormat: string;
        isWidgetFilter: boolean;
        minWidth: string;

        onPreviousDateClick: Function;
        onNextDateClick: Function;
        dateRangeSettings: DevExpress.ui.dxDateRangeBox.Properties;
        dateRangeComponent: DevExpress.ui.dxDateRangeBox;
        nullButtonParams: Ir.Components.Filters.NullButton.INullButtonParams;

        getFormattedDate: Function;
    }
    
    export function getViewModel(this: IDateRangeFilterViewModel, params: IFilterParameterVM, componentInfo) {
        let self = this;
        this.filter = params.filter;
        
        this.dateRanges = DateRangeService.DatesRange;

        this.isWidgetFilter = params.isWidgetFilter
        $(componentInfo.element).addClass("dateRange-filter-comp");

        this.filter.previousDateClick = function () {
            self.filter.nextPreviousDateChange(false, self.dateRanges, componentInfo.element, self.isWidgetFilter);
        };
        this.filter.nextDateClick = function () {
            self.filter.nextPreviousDateChange(true, self.dateRanges, componentInfo.element, self.isWidgetFilter);
        };

        this.dateFormat = irSettings.shortDateFormat;
        let allCustomDate = this.dateRanges.find(x => x.id() === irGlobal.customDate.all);

        this.getFormattedDate = function (startCondition, endCondition) {
            if (startCondition && endCondition) {
                let startDisplayDate = null;
                if (startCondition && startCondition !== allCustomDate.startDate()) {
                    let startDate = DevExpress.localization.parseDate(startCondition, "yyyy-MM-dd");
                    startDisplayDate = DevExpress.localization.formatDate(startDate, self.dateFormat);
                }
                else {
                    startDisplayDate = allCustomDate.initials();
                }

                let endDisplayDate = null;
                if (endCondition && endCondition !== allCustomDate.endDate()) {
                    let endDate = DevExpress.localization.parseDate(endCondition, "yyyy-MM-dd");
                    endDisplayDate = DevExpress.localization.formatDate(endDate, self.dateFormat);
                }
                else {
                    endDisplayDate = allCustomDate.initials();
                }

                if (startDisplayDate === allCustomDate.initials() && endDisplayDate === allCustomDate.initials()) {
                    return allCustomDate.initials();
                }

                return `${startDisplayDate} - ${endDisplayDate}`;
            }

            return irSettings.nullText;
        };

        if (this.filter.dateRange() === irGlobal.customDate.all) {
            this.filter.startDisplayCondition(allCustomDate.initials());
        }
        else {
            this.filter.startDisplayCondition(this.getFormattedDate(this.filter.startCondition(), this.filter.endCondition()));
        }

        this.filter.startEndDateRangeTmp(this.filter.dateRange() === irGlobal.customDate.all ? [null, null] :
            [this.filter.startCondition() == allCustomDate.startDate() ? null : this.filter.startCondition(),
            this.filter.endCondition() == allCustomDate.endDate() ? null : this.filter.endCondition()]);
        
        let updatingDateRangeType = false;
        let needPublish = false;
        let updatingDateManually = false;
        this.minWidth = this.isWidgetFilter ? "140px" : "unset";
        this.dateRangeSettings = {
            disabled: ko.computed(function () {
                return self.filter.readOnly() || self.filter.scopeAction() === ScopeActionEnum.Combine;
            }) as any,
            multiView: false,
            width: 140,
            displayFormat: this.dateFormat,
            value: this.filter.startEndDateRangeTmp as any,
            labelMode: "hidden",

            showClearButton: false,
            openOnFieldClick: true,
            showDropDownButton: false,
            startDatePlaceholder: ko.computed(function () {
                return self.filter.startCondition() === null ? "" : "All";
            }) as any,
            endDatePlaceholder: ko.computed(function () {
                return self.filter.endCondition() === null ? "" : "All";
            }) as any,
            startDateInputAttr: { onfocus: "this.select()" },
            endDateInputAttr: { onfocus: "this.select()" },
            onFocusIn: function (e) {
                e.element.select();
            },
            onOpened: function (e) {
                updatingDateManually = true;
            },
            onInitialized(e) {
                self.filter.getComponent = function () { return e.component; };
                self.dateRangeComponent = e.component;
            },
            onValueChanged: function (e) {
                let previousStartDate = e.previousValue[0];
                let previousEndDate = e.previousValue[1];
                let startDate = e.value[0];
                let endDate = e.value[1];
                
                if (previousStartDate !== startDate || previousEndDate !== endDate) {
                    if (!updatingDateRangeType) {
                        self.filter.dateRange(irGlobal.customDate.custom);
                        self.filter.dateRangeConfig.userDates(true);
                        self.filter.dateRangeConfig.lastDateUsed(null);
                        self.filter.dateRangeConfig.startDate(null);
                        self.filter.dateRangeConfig.endDate(null);
                    }
                    else {
                        self.filter.dateRangeConfig.userDates(false)
                    }

                    self.filter.dateRangeConfig.multiplier(0);

                    updatingDateRangeType = false;
                    if (typeof startDate === "object" && startDate) {
                        startDate = DevExpress.localization.formatDate(startDate, "yyyy-MM-dd")
                    }
                    if (typeof endDate === "object" && endDate) {
                        endDate = DevExpress.localization.formatDate(endDate, "yyyy-MM-dd")
                    }
                    
                    if (self.filter.dateRange() === irGlobal.customDate.all) {
                        self.filter.startCondition(allCustomDate.startDate());
                        self.filter.endCondition(allCustomDate.endDate());
                        self.filter.startDisplayCondition(allCustomDate.initials());
                    }
                    else {
                        self.filter.startCondition(startDate);
                        self.filter.endCondition(endDate);
                        self.filter.startDisplayCondition(self.getFormattedDate(self.filter.startCondition(), self.filter.endCondition()));
                    }

                    if (self.isWidgetFilter && updatingDateManually) {
                        //When is widget filter, publish the values ​​only when closing the popup
                        needPublish = true;
                    }
                    else {
                        self.filter.publish();
                    }
                }
            },
            onClosed: function (e) {
                updatingDateManually = false;

                if (needPublish) {
                    self.filter.publish();
                }
            },
            onContentReady: function (e) {
                if (self.filter.onContentReady) {
                    self.filter.onContentReady();
                }
            }
        }

        this.filter.dateRange.subscribe(function (newValue) {
            if (irGlobal.customDate.custom !== newValue) {
                let dateRange = self.dateRanges.find(function (x) { return x.id() === newValue; });
                if (dateRange) {
                    updatingDateRangeType = true;
                    if (dateRange.id() === irGlobal.customDate.all) { //All
                        self.filter.startEndDateRangeTmp([null, null]);
                    }
                    else {
                        self.filter.startEndDateRangeTmp([dateRange.startDate(), dateRange.endDate()]);
                    }
                }
            }
        });

        if (this.filter.animate()) {
            this.filter.animate(false);

            const filterElement = $(componentInfo.element).closest("li.filter");
            const filterListElement = filterElement.closest("ul");
            if (filterListElement.children().length == 1) {
                filterListElement.css("overflow", "hidden");
            }

            filterElement.addClass(["animate__animated", "animate__headShake"]);
            filterElement.off("animationend").on("animationend", () => {
                filterListElement.css("overflow", "");
                filterElement.removeClass(["animate__animated", "animate__headShake"]);
            });
        }

        this.nullButtonParams = {
            filter: this.filter,
            visible: this.filter.showNullButton(),
            onItemClick(e) {
                if (self.filter.startCondition() === null) {
                    self.filter.dateRange(irGlobal.customDate.today);
                }
                else {
                    self.filter.startEndDateRangeTmp([null, null]);
                    self.filter.startDisplayCondition(irSettings.nullText);
                }

                self.filter.publish();
                self.dateRangeComponent.element().focus();
            }
        };
    }
}